import { createRouter, createWebHistory } from "vue-router";

const TransactionalDashboard = import(
  /* webpackChunkName: "TransactionalDashboard" */ "../views/TransactionalEmail/TransactionalDashboard.vue"
);
const TransactionalWebhookCreate = import(
  /* webpackChunkName: "TransactionalWebhookCreate" */ "../components/TransactionalEmail/TransactionalWebhookCreate.vue"
);
const TransactionalWebhookEdit = import(
  /* webpackChunkName: "TransactionalWebhookEdit" */ "../components/TransactionalEmail/TransactionalWebhookCreate.vue"
);
const TransactionalActivities = import(
  /* webpackChunkName: "TransactionalActivities" */ "../views/TransactionalEmail/TransactionalActivities.vue"
);
const TransactionalSettings = import(
  /* webpackChunkName: "TransactionalSettings" */ "../views/TransactionalEmail/TransactionalSettings.vue"
);
const TransactionalUsage = import(
  /* webpackChunkName: "TransactionalUsage" */ "../views/TransactionalEmail/TransactionalUsage.vue"
);
const ErrorView = import(
  /* webpackChunkName: "ErrorView" */ "../views/ErrorView.vue"
);

const routes = [
  {
    path: "/transactional/webhook-create",
    name: "TransactionalWebhookCreate",
    component: () => TransactionalWebhookCreate,
  },
  {
    path: "/transactional/webhook-edit/:id",
    name: "TransactionalWebhookEdit",
    component: () => TransactionalWebhookEdit,
  },
  {
    path: "/transactional/usage",
    name: "TransactionalUsage",
    component: () => TransactionalUsage,
  },
  {
    path: "/transactional/settings",
    name: "TransactionalSettings",
    component: () => TransactionalSettings,
  },
  {
    path: "/transactional/activities",
    name: "TransactionalActivities",
    component: () => TransactionalActivities,
  },
  {
    path: "/transactional/dashboard",
    name: "TransactionalDashboard",
    component: () => TransactionalDashboard,
  },
  {
    path: "/:catchAll(.*)",
    name: "PageNotFound",
    component: ErrorView,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
